// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
class ServiceArea extends React.Component {
  renderState = (state, counties = [], totalCountiesInState) => (
    <div key={`state-${state}`}>
      <span className='pro-label green' key={`state-${state}`}>
        {state}
      </span>
      {counties.length === totalCountiesInState
        ? (
          <span className='pro-label grey' key={`county-${state}-all}`}>
            Entire State
          </span>
          )
        : (
            counties.map((county) => (
              <span className='pro-label grey' key={`county-${state}-${county}`}>
                {county}
              </span>
            ))
          )}
    </div>
  )

  renderNational = () => {
    return (
      <div className='small-12 cell'>{this.renderState('United States')}</div>
    )
  }

  renderCanada = () => {
    return <div className='small-12 cell'>{this.renderState('Canada')}</div>
  }

  render () {
    const { national, canada, counties_by_state: countiesByState = {} } = this.props.serviceAreas

    return (
      <div id='service-areas' className='content'>
        {national
          ? this.renderNational()
          : Object.keys(countiesByState).map((state) =>
            this.renderState(
              countiesByState[state].state_name,
              countiesByState[state].counties,
              countiesByState[state].total_counties_in_state
            )
          )}
        {canada ? this.renderCanada() : ''}
      </div>
    )
  }
}

ServiceArea.propTypes = {
  serviceAreas: PropTypes.shape({
    national: PropTypes.bool,
    canada: PropTypes.bool,
    counties_by_state: PropTypes.object
  }).isRequired
}

export default ServiceArea
